import React from 'react'

import { Box, Typography } from '@material-ui/core'

const TextMessage = ({ message, justify }) => {
  return (
    <Box p={1} display={'flex'} justifyContent={justify}>
      <Typography variant={'body1'} align={'left'} style={{ wordBreak: 'break-word' }}>
        {message}
      </Typography>
    </Box>
  )
}

export default TextMessage
